import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  input: {
    border: `1px solid #BFBBBD`,
    borderRadius: '8px',
    '&:focus': {
      borderColor: theme.palette.primaryPure,
    },
  },
}));

export default useStyles;
